export const NOTIFICATION_TYPE = {
  NOTIF_BUBBLE_ADD: 1, // general addition
  NOTIF_BUBBLE_REDEMPTION: 2, // redemption page
  NOTIF_BUBBLE_REFUND: 3, // refund if the gift is out of stock
  NOTIF_BUBBLE_WS_COMPLETE: 4, // reward after completing the worksheet
  NOTIF_WS_ASSIGNED: 5, // worksheet assigned by teacher
  NOTIF_WS_MARKED: 6, // worksheet marked by teacher
  NOTIF_ANSWER_COMMENTED: 7, // new comment on submitted answer from teacher
  NOTIF_DEV_MSG: 8, // free text message from developer
  NOTIF_NEW_QUESTION_COMMENT: 9, // free text message from developer
  NOTIF_BUBBLES_ADJUSTMENT_FROM_ADMIN: 10, // when admin adjust bubbles manually from "Admin -> Student" page

  // notification parent
  NOTIFICATION_WORKSHEET_MARKED: 11,
  NOTIFICATION_WORKSHEET_DUE: 12,
  NOTIFICATION_PIN_TOPIC: 13,
  NOTIFICATION_EXAM_RESULT: 14,
  NOTIFICATION_WORKSHEET_ASSIGNMENT: 15,
  NOTIFICATION_PUBLIC_HOLIDAY: 16,
  NOTIFICATION_REPLACEMENT_LESSON: 17,
  NOTIFICATION_CONCEPT_IMPROVEMENT: 18,
  NOTIFICATION_WEAK_CONCEPT: 19,

  // notification challenge
  NOTIF_CHALLENGE_SENT: 20, // challenge send (probably thru random users, or maybe we don't need this at all)
  NOTIF_CHALLENGE_RECEIVED: 21, // when someone accepted the challenge, regardless thru random challenge or direct challenge (future feature?), or sharing the code
  NOTIF_CHALLENGE_ACCEPTED: 22, // when someone accept the challenge
  NOTIF_CHALLENGE_COMPLETED: 23, // when someone completed the challenge
  NOTIF_CHALLENGE_REWARD_SHARER: 24, // bubbles reward for completing the challenge
  NOTIF_CHALLENGE_REWARD_RECEIVER: 25, // bubbles reward for completing the challenge
  NOTIF_CHALLENGE_RECEIVER_COMPLETED: 26, // when you complete the challenge from someone (to compare the score)

  // notification LP
  NOTIF_LEARNER_PROFILE_NEW_DA: 31, // when new DA arranged from admin page
  NOTIF_LEARNER_PROFILE_DA_REMINDER: 32, // DA reminder
  NOTIF_LEARNER_PROFILE_DA_CANCELLED: 33, // DA cancelled
  NOTIF_LEARNER_PROFILE_DA_UPDATED: 34, // DA updated
  NOTIF_CONCEPT_IMPROVEMENT: 40, // concept improvement / score dropped
  NOTIF_CONCEPT_WEAK: 41, // weak concepts
  NOTIF_WORKSHEET_DUE: 42, // worksheet near due
  NOTIF_PIN_TOPIC: 43, // when student pinned topic
  NOTIF_EXAM_RESULT: 44, // when student uploaded exam result
  NOTIFICATION_WORKSHEET_ACTIVITY: 45, // when student do something with worksheet
  NOTIF_EXAM_RESULT_REWARD: 46,
  NOTIF_EXAM_RESULT_REJECTED: 47,

  // notification revision group
  NOTIFICATION_REVISION_GROUP: 50,

  // notification study plan
  NOTIFICATION_STUDY_PLAN: 70, // when system autogenerates ws for student (last attempt = 7 days)

  // notification online lesson
  NOTIFICATION_ONLINE_LESSON: 80,
  NOTIF_BUBBLE_ONLINE_LESSON_REWARD: 81,
  NOTIFICATION_ONLINE_LESSON_START: 82,
  NOTIFICATION_ONLINE_LESSON_RECORDED: 83,
  NOTIFICATION_GENIECLASS_ATTENDANCE: 84,
  NOTIFICATION_ONLINE_LESSON_UPCOMING: 85,
  NOTIFICATION_GENIECLASS_PERFORMANCE: 86,
  NOTIFICATION_GENIECLASS_PRECLASS: 87,
  NOTIFICATION_GENIECLASS_POSTCLASS: 88,
  NOTIFICATION_GENIECLASS_BUBBLE_LIMIT: 89,
  NOTIFICATION_GENIECLASS_WORKSHEET_ASSIGNED: 91,
  NOTIFICATION_GENIECLASS_PARENT_FEATURE: 141,
  NOTIFICATION_GENIECLASS_TO_GENIESMART: 191,

  // notification student exam result
  NOTIFICATION_REMINDER_EXAM_RESULT: 151,

  // notification leaderboard
  NOTIFICATION_LEADERBOARD: 90, // old leaderboard notif can't be use anymore, need to change to new type
  NOTIFICATION_NEW_LEADERBOARD_ENDING: 92,
  NOTIFICATION_NEW_LEADERBOARD_ENDED: 93,

  // notification user engagement
  NOTIFICATION_LAST_LOGIN: 100, // when user never login for a long time
  NOTIFICATION_LOW_ATTEMPT: 101, // low attempt alert / reminder

  // notification head
  NOTIFICATION_HEAD_EMAIL: 51,
  NOTIFICATION_HEAD_PN: 52,

  // notification ws
  NOTIF_WS_REOPEN: 60,
  NOTIF_ASSIGN_WS: 61,

  // notification ab group testing
  NOTIFICATION_PERSONALISED_LEARNING_JOURNEY: 111,
  NOTIFICATION_PROGRESS_REPORT: 113,
  NOTIFICATION_LETS_DO_MORE: 114,
  NOTIFICATION_GENIEBOOK_STREAKS: 116,

  NOTIFICATION_BOOST: 117, // For parent encouragement experiment

  NOTIF_BADGE_EARNED: 120, // new badge earned by the student

  // ----- GenieAsk -----
  NOTIFICATION_GENIEASK: 121,
  NOTIFICATION_STUDENT_ADDED_TO_CLASS: 122,
  NOTIFICATION_STUDENT_REMOVE_FROM_CLASS: 123,

  NOTIFICATION_GENIEASK_MENTION: 124,
  NOTIFICATION_GENIEASK_PRIVATE_MESSAGE: 125,
  NOTIFICATION_GENIEASK_TEACHER_PINNED: 126,

  NOTIFICATION_GENIEASK_REPLY: 127,
  NOTIFICATION_GENIEASK_SUBSCRIPTION_END: 128,
  NOTIFICATION_GENIEASK_BROADCAST: 129,
  NOTIFICATION_GENIEASK_POLL: 130,

  NOTIFICATION_STREAK_V2_NORMAL: 131,
  NOTIFICATION_STREAK_V2_SALVAGED: 132,
  NOTIFICATION_STREAK_V2_RESET: 133,

  NOTIF_BUBBLE_PARENT_TRANSFER: 160, // When parent give/transer bubble to student
  NOTIFICATION_MASTERY_LEVEL_INCREASED: 170,
  NOTIFICATION_MASTERY_LEVEL_DECREASED: 171,
  NOTIFICATION_MASTERY_LEVEL_DECAYED: 172,
  NOTIFICATION_DIAGNOSTIC_ASSESSMENT_ASSIGNED: 180,
  NOTIF_BUBBLE_EXPIRED: 181,

  NOTIFICATION_WS_HOMEWORK_ASSIGNED: 190, // when teacher assign homework on GBT Hybrid
};
